
import { MORE_1024_MEDIA_QUERY, MORE_768_MEDIA_QUERY } from '../../../consts/adaptive';

export const styles = {
    container: {
        paddingTop: 22,
        paddingBottom: 26,
        backgroundColor: '#fff'
    },
    title: {
        marginBottom: 10,
        fontSize: 16,
        fontWeight: 'bold'
    },
    mobileFacilitiesList: {},
    openButton: {
        padding: [10, 12, 0, 12],
        height: 46,
        fontSize: 16,
        color: '#0087BE',
        boxSizing: 'border-box',
        borderTop: '1px solid #c4c4c4',
        borderBottom: '1px solid #c4c4c4',
        backgroundColor: '#fff'
    },
    openButtonTitle: {
        float: 'left',
        fontSize: 16,
        lineHeight: '20px'
    },
    arrow: {
        float: 'right',
        transform: 'rotate(180deg)'
    },
    facilities: {
        display: 'none',
        boxSizing: 'border-box'
    },
    description: {
        lineHeight: '24px',
        fontSize: 14,
        boxSizing: 'border-box'
    },
    emptyText: {
        padding: [0, 12],
        lineHeight: '24px',
        fontSize: 14,
        marginTop: 30
    },
    collapser: {
        position: 'relative',
        minHeight: 125,
        cursor: 'pointer',

        '&::after': {
            content: '""',
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%',
            height: '50px',
            backgroundImage: 'linear-gradient(rgba(255, 255, 255, 0), #fff)',
            opacity: 1,
            pointerEvents: 'none',
            transition: 'opacity 0.225s linear'
        }
    },
    openedCollapser: {

        '&::after': {
            opacity: 0
        }
    },
    descriptionEmptyCollapser: {
        minHeight: 50
    },
    collapserContent: {
        paddingTop: 20,
        overflow: 'hidden'
    },
    facilitiesContent: {
        paddingTop: 20,
        overflow: 'auto'
    },
    showMore: {
        paddingLeft: 12,
        fontSize: 14,
        color: '#0087BE',
        cursor: 'pointer'
    },
    showMoreText: {},
    arrowDown: {
        display: 'none',
        transform: 'rotate(-90deg)'
    },
    mobileHidden: {
        display: 'none'
    },
    videoContainer: {
        paddingTop: 22,
        paddingBottom: 26,
        backgroundColor: '#fff'
    },
    videoEmbed: {
        top: 0,
        left: 0,
        width: '100%',
        height: '100%'
    },

    [MORE_768_MEDIA_QUERY]: {
        container: {
            paddingTop: 36,
            paddingBottom: 46
        },
        title: {
            fontSize: 20,
            marginBottom: 16
        },
        mobileFacilitiesList: {
            display: 'none'
        },
        collapser: {
            minHeight: 200
        },
        descriptionEmptyCollapser: {
            minHeight: 200
        },
        collapserContent: {
            paddingTop: 10,
        },
        facilitiesContent: {
            paddingTop: 20,
        },
        facilities: {
            display: 'block',
        },
        showMore: {
            padding: 0,
            fontSize: 16,
            textAlign: 'center'
        },
        showMoreText: {
            marginRight: 15,
            borderBottom: '1px dashed #0087BE'
        },
        arrowDown: {
            display: 'inline-block'
        },
        mobileHidden: {
            display: 'block'
        },
        videoContainer: {
            paddingTop: 36,
            paddingBottom: 46,
            maxWidth: '50%',
            minWidth: 853,
            minHeight: 450,
            position: 'relative'
        },
        videoEmbed: {
            position: 'absolute'
        }
    },

    [MORE_1024_MEDIA_QUERY]: {
        container: {
            paddingTop: 44,
            paddingBottom: 43
        },
        title: {
            fontSize: 20,
            marginBottom: 19
        }
    }
};

export type ComponentJSSClasses = typeof styles;
